import { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectToken } from '../authentication/authenticationSlice'

import api, { isHTTPError } from '../api'

const useGetDatasets = () => {
  const token = useSelector(selectToken)
  const [datasets, setDatasets] = useState([])
  const [loadingDatasets, setLoadingDatasets] = useState(false)
  const [datasetsError, setDatasetsError] = useState('')

  const getDatasets = async (organizationId: number) => {
    setLoadingDatasets(true)
    setDatasetsError('')
    
    try {
      const response = await api.getDatasets({ organizationId, token })
      setDatasets(response.datasets || [])
      setLoadingDatasets(false)
      return response
    } catch (error) {
      if (
        // @ts-ignore
        error.hasOwnProperty('response') &&
        isHTTPError(error) &&
        'detail' in error.response.data
      ) {
        setDatasetsError(
          `Error ${error.response.status}: ${error.response.data.detail}`
        )
      } else {
        setDatasetsError("Can't connect to the server")
      }
      setLoadingDatasets(false)
      throw error
    }
  }

  return {
    getDatasets,
    datasets,
    loadingDatasets,
    datasetsError,
  }
}

export default useGetDatasets